import { IStyles } from 'app/utils/css';

export const BOX_SHADOW_A = '0px 1px 1px rgba(0,0,0,0.2)';
export const BOX_SHADOW_B = '0px 2px 10px rgba(0,0,0,0.2)';
export const BOX_SHADOW_C = '0px 2px 6px rgba(0,0,0,0.2)';
export const BOX_SHADOW_D = '0px 1px 6px rgba(0,0,0,0.1)';

export const TEXT_SHADOW_A = '0 0 0.3em #000';

export const TRANSITION_DURATION_A = '0.15s';
export const TRANSITION_DURATION_B = '0.1s';

export const ANNOTATION_FONT_SIZE = '0.8em';

export const BORDER_RADIUS_A = '3px';
export const BORDER_RADIUS_B = '2px';

export const LETTER_SPACING_A = '0.05em';

export const MARGIN_A = '2em';

// It is not necessary to add aliases for *every* style here, you can now just use the above
// abitrarily-named constants in component files directly.
export const LESSON_CARD_BOX_SHADOW = BOX_SHADOW_A;
export const LESSON_CARD_HIGHLIGHTED_BOX_SHADOW = BOX_SHADOW_C;
export const DAILY_NEWS_BANNER_BOX_SHADOW = BOX_SHADOW_A;
export const SEARCH_INPUT_BOX_SHADOW = BOX_SHADOW_A;
export const SEARCH_INPUT_FOCUS_BOX_SHADOW = BOX_SHADOW_C;
export const DROPDOWN_OVERLAY_BOX_SHADOW = BOX_SHADOW_B;
export const LESSONBOX_BOX_SHADOW = BOX_SHADOW_A;
export const LEVEL_SLIDER_HANDLE_BOX_SHADOW = BOX_SHADOW_D;
export const TOOLTIP_BOX_SHADOW = BOX_SHADOW_A;
export const EDITOR_VALIDATIONS_BOX_SHADOW = BOX_SHADOW_B;

export const DAILY_NEWS_HOVER_STATE_TRANSITION_DURATION = TRANSITION_DURATION_A;
export const TAB_TRANSITION_DURATION = TRANSITION_DURATION_A;
export const LEVEL_SLIDER_HANDLE_TRANSITION_DURATION = TRANSITION_DURATION_B;

export const ANSWER_FONT_SIZE = '14px';

// NOTE: `brightness(100%) contrast(100%)` needs to be specified in the non-highlighted style to
// make the transition work in Safari.
export const getImageHighlightFilter = (highlighted: boolean) => (
  highlighted ? 'brightness(105%) contrast(110%)' : 'brightness(100%) contrast(100%)'
);

// Apply to <button> elements to remove all user agent styles
export const buttonReset: IStyles = {
  display: 'inline-block',
  border: 'none',
  padding: '0',
  margin: '0',
  textDecoration: 'none',
  background: 'transparent',
  color: 'inherit',
  fontFamily: 'inherit',
  fontSize: 'inherit',
  cursor: 'pointer',
  textAlign: 'center',
  WebkitAppearance: 'none',
  MozAppearance: 'none',
};

// Apply to <ul>/<ol> elements to remove all user agent styles
export const listReset: IStyles = {
  listStyle: 'none',
  margin: '0',
  padding: '0',
};

// Apply when cascading flex containers.
export const flexCascade: IStyles = {
  display: 'flex',
  flex: 'auto',
  flexDirection: 'column',
};

// Fix for Firefox printing bug https://bugzilla.mozilla.org/show_bug.cgi?id=939897
// Should be applied on all large containers with display:flex
// '@media print': firefoxPrintHackStyles
export const firefoxPrintHackStyles: IStyles = {
  display: 'block',
};
